

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';
import{PurchaseDetails} from '../../../@core/interfaces/masters/purchasedetails';
import { AnyRecord } from 'dns';



export interface PurchaseParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface Purchase {
  taxType:string;
  
  supplier: any;
   
  grnId: string;

  grnDate: any;
 
  invValue: Number;

  invDate: any;

  invDueDate: any;

invNo: string;

supplierId: string; 

grnTotal: Number; 

grnDiscType: string;

grnDiscPer: Number;

grnDiscAmt: Number; 

grnTaxTotal: Number; 



iGst: Number;

cGst: Number;

  sgstOrUtgst: Number; 

  creditNoteValue: Number;

 returnValue: Number;

  roundOffMode: string;

  roundOffAmt: Number;

  comments: string;

  grnNetTotal: Number;

  grnStatus: string; 

  createdBy: string; 

  createdDate: any;

  grnDiscValue: Number;
  
  grnDiscTotal: Number;

  //New Column
  
  updatedBy: any; 
  updatedDate: Date;
  updatedIP: string;  
  createdIP: string;  
  gridDiscountAfterTax:string;
  totalDiscountAfterTax: string;
  purchaseDetDto: PurchaseDetails[];
  tenantId?: string;
  branchId?: string;    
  
    parameters?: PurchaseParameter[];
    links?: any;

    pharmacyId?:any;
    poId:number;
    poNo:string;
    poDate:string;
    warehouseId:number;
    gstforFreeQty:string;
    challanNo?:string;
    challanDate?:Date;
    isOldGstGrnEntry:boolean;
}
export interface SupplierInvoice{
  purchaseDate : Date;
 purchaseId : string;
supplierId : string;
 supplierName:string;                               
 supplierInvNo:string;                              
 supplierInvDate :Date;
creditDays :number;
 dueDate:Date;
pendingDays:number;
 purchaseAmount:number;
purchaseReturnAmount:number;
paid:number;
balance:number;
tenantId:string;
 branchId:string;
}
export interface DistinctSupplier{
  supplierId:string;
  supplierName:string;
}
export interface consolidReport{
  supplierName:string;
 productName:string;
  category:string ;
  batchNumber :string;
  purchaseDate:Date;
  expiryDate :Date;
  pack:number;
  qty :number;
  freeQty:number;
  costPrice :number;
  mrp:number;
  gst_total:number;
  mrpValue:number;
  costValue:number;
}
 
export abstract class PurchaseData {
  
  abstract list(url: string): Observable<Purchase[]>;
  abstract create(url: string,data: Purchase): Observable<any>;
  abstract update(url: string,data: Purchase): Observable<any>;
  
    abstract searchSupplier_Inv_List(url: string, data:any): Observable<any>;
    
  abstract supplierList(url:string):Observable<Purchase[]>;
  abstract delete(url: string): Observable<any>;
   abstract supplierInvoiceList(url:string):Observable<SupplierInvoice[]>;
    abstract supplierInvoiceListById(url:string):Observable<any>;
    abstract searchList(url: string,data:any): Observable<any>;
    abstract consolidSupplierWiseReport(url: string,data:any): Observable<consolidReport[]>;
    abstract consolidDateWiseReport(url: string,data:any): Observable<consolidReport[]>;
    abstract distinctSupplier(url:string):Observable<any>;
      abstract searchInv_List(url: string): Observable<any>;
    
}
